// extracted by mini-css-extract-plugin
export default {"page":"PrintScoreForms_page__4XmgM","header":"PrintScoreForms_header__g5rsh"};